var map = {
	"./Blood Pressure disabled.svg": 814,
	"./Blood Pressure.svg": 815,
	"./Body Temp disabled.svg": 816,
	"./Body Temp.svg": 817,
	"./Check.svg": 134,
	"./Configurations.svg": 818,
	"./Countries.svg": 819,
	"./Edit.svg": 83,
	"./Ellipse.svg": 820,
	"./Expand.svg": 279,
	"./Eye-hide.svg": 412,
	"./Eye-show.svg": 413,
	"./Flag.svg": 821,
	"./Fota.svg": 822,
	"./Glucose disabled.svg": 823,
	"./Glucose.svg": 824,
	"./Hide.svg": 238,
	"./Home.svg": 825,
	"./Inbox.svg": 826,
	"./My Profile.svg": 827,
	"./Next.svg": 349,
	"./PDF.svg": 350,
	"./PathEcg.svg": 828,
	"./Patient List.svg": 829,
	"./Patient Requests.svg": 830,
	"./Patients.svg": 831,
	"./Physicians.svg": 832,
	"./Prev.svg": 351,
	"./Pulse Rate disabled.svg": 833,
	"./Pulse Rate.svg": 834,
	"./Reports.svg": 835,
	"./Respiration Analysis.svg": 836,
	"./Respiratory Rate disabled.svg": 837,
	"./Respiratory Rate.svg": 838,
	"./Search.svg": 233,
	"./Show.svg": 239,
	"./SpO2 disabled.svg": 839,
	"./SpO2.svg": 840,
	"./Versions.svg": 841,
	"./Viewers.svg": 842,
	"./Weight disabled.svg": 843,
	"./Weight.svg": 844,
	"./af-report-icon.svg": 414,
	"./af.svg": 845,
	"./afDetected.svg": 846,
	"./afNotDetected.svg": 847,
	"./alerton.svg": 129,
	"./annotations-report-icon.svg": 415,
	"./app_disconnected.svg": 352,
	"./arrow-down.svg": 130,
	"./arrythmia-filter.svg": 240,
	"./avatar.svg": 353,
	"./bell.svg": 187,
	"./blood-pressure-report-icon.svg": 416,
	"./calander.svg": 354,
	"./calories.svg": 848,
	"./checkbox.svg": 355,
	"./circle.svg": 849,
	"./clock.svg": 417,
	"./common/github.svg": 850,
	"./common/google.svg": 851,
	"./daily-report-icon.svg": 418,
	"./events-report-icon.svg": 419,
	"./generate-unique-id.svg": 356,
	"./grid-off.svg": 420,
	"./grid.svg": 421,
	"./hamburger.svg": 852,
	"./list-on.svg": 422,
	"./list.svg": 423,
	"./medcine_reminder.svg": 357,
	"./monthly-report-icon.svg": 424,
	"./notMeasured.svg": 853,
	"./offwrist.svg": 188,
	"./pinnedoff.svg": 358,
	"./pinnedon.svg": 241,
	"./print.svg": 411,
	"./pwv-report-icon.svg": 425,
	"./reminder_clock.svg": 359,
	"./remindmelater.svg": 360,
	"./remove-doctor.svg": 280,
	"./rsi.svg": 854,
	"./saturation-report-icon.svg": 426,
	"./search-circle.svg": 855,
	"./send-circle.svg": 281,
	"./sleep-apnea-report-icon.svg": 427,
	"./sleep.svg": 856,
	"./sort.svg": 135,
	"./sort_list.svg": 361,
	"./steps.svg": 857,
	"./tike.svg": 858,
	"./timefilter.svg": 362,
	"./trash.svg": 131,
	"./vi.svg": 363,
	"./watch_diconnected.svg": 364
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 278;